import { useParams } from 'react-router-dom';

import React from 'react';
import containers from './containersCategoryData.json';
import ContainersWrapper from 'components/ContainersWrapper/ContainersWrapper';

export default function ContainersCategory() {
  const { category } = useParams();
  // console.log('container99', container);
  // console.log('containerss444', containers[container]);

  return (
    <>
      {containers && (
        <ContainersWrapper containers={containers[category]} link={true} />
      )}
    </>
  );
}
